function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDotIndicatorUnfilled = function SvgDotIndicatorUnfilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10 15.5c3 0 5.5-2.5 5.5-5.5S13 4.5 10 4.5 4.5 7 4.5 10 7 15.5 10 15.5zm0 2c4.1 0 7.5-3.4 7.5-7.5S14.1 2.5 10 2.5 2.5 5.9 2.5 10s3.4 7.5 7.5 7.5z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }));
};
export default SvgDotIndicatorUnfilled;